<div class="close-btn-outer">
  <button mat-mini-fab color="warn" (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content>
  <div class="row wrap">
    <div class="d-flex align-items-center" style="padding-bottom: 5px">
      <input
        type="text"
        class="width-form"
        [(ngModel)]="addressInput"
        placeholder="Buscar ubicación"
      />
      <button
        style="margin-left: 5px"
        (click)="searchLocation()"
        mat-raised-button
        color="primary"
      >
        {{ "TRANSLATE.SEARCH_0" | translate }}
      </button>
    </div>
  </div>

  <div class="map-container">
    <div class="map-frame">
      <div id="mapDetail"></div>
    </div>
  </div>
</div>
<mat-dialog-actions class="row">
  <div class="col-lg-12">
    <div
      class="d-flex justify-content-between align-items-start flex-row flex-xs-column text-muted"
    >
      <div>
        <mat-checkbox
          [checked]="this.activeReplace"
          (change)="changeCheck($event)"
        >
        </mat-checkbox>
        <span style="margin-left: 5px">
          {{ "TRANSLATE.REMPLACE_MAP_ADDRESS" | translate }}</span
        >
      </div>
      <div>
        <div class="button-container">
          <div class="spinner-container" *ngIf="loadSave">
            <mat-spinner diameter="24"></mat-spinner>
          </div>
          <button
            (click)="onSave()"
            type="submit"
            mat-raised-button
            class="button-save"
          >
            {{ "TRANSLATE.SAVE" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-actions>
